/** Formats an HttpErrorResponse into a readable string, handling FastAPI's validation-error
 * shape where `detail` is an array of `{msg, loc, type}` objects instead of a plain string. */
export function formatError(err: unknown, fallback = 'Something went wrong. Please try again.'): string {
  const detail = (err as { error?: { detail?: unknown } })?.error?.detail;
  if (Array.isArray(detail)) {
    // Pydantic prefixes errors raised by our own validators with "Value error, "
    return detail.map((e) => (e?.msg ?? JSON.stringify(e)).replace(/^Value error, /, '')).join(' ');
  }
  if (typeof detail === 'string') {
    return detail;
  }
  return fallback;
}
